/** High-level progress for sitebuilder generation (onboarding + preview). */

export const SITE_BUILD_STEPS = [
  { label: "Setting up", hint: "Repository and workspace" },
  { label: "Writing data", hint: "Publishing table snapshots" },
  { label: "Building Site", hint: "Customizing the template" },
  { label: "Going Live", hint: "Final review and preview" },
];

// setup → Setting up; data/brand/media/planner → Writing data;
// design + coding stages → Building Site; review → Going Live
const STEP_BY_RUN_LABEL = {
  setup: 0,
  branding: 1,
  data: 1,
  media: 1,
  planner: 1,
  design: 2,
  scaffold: 2,
  chrome: 2,
  copy: 2,
  ui: 2,
  polish: 2,
  taste: 2,
  review: 3,
  qa: 3,
};

export function siteBuildStepIndex(project, buildChange) {
  if (!project) return 0;
  if (project.status === "live" || project.status === "ready") return SITE_BUILD_STEPS.length;
  if (buildChange?.status === "completed" || buildChange?.status === "published") {
    return SITE_BUILD_STEPS.length;
  }

  const runs = buildChange?.agent_runs || [];
  const active = [...runs]
    .reverse()
    .find((run) => run.status === "running" || run.status === "pending");
  if (active) {
    const byLabel = STEP_BY_RUN_LABEL[active.run_label];
    if (byLabel != null) return byLabel;
    // Unlabeled sitebuilder coding runs still count as Building Site.
    if (active.agent_type === "sitebuilder" || active.agent_type === "coding") return 2;
  }

  // Between runs: sit on the next step after the furthest succeeded mapped run.
  let furthest = -1;
  for (const run of runs) {
    const step = STEP_BY_RUN_LABEL[run.run_label];
    if (step == null || run.status !== "succeeded") continue;
    furthest = Math.max(furthest, step);
  }
  if (furthest >= 0) {
    return Math.min(furthest + 1, SITE_BUILD_STEPS.length - 1);
  }

  return 0;
}
